/**
 * The ProductDescription component renders the bottom part of the product
 * where you can find the title and the description of the product.
 */
import React, { PropTypes, PureComponent } from 'react';

class ProductDescription extends PureComponent {

  render() {
    return (
      <div className={this.props.className}>
        <div className="mt-product-description-inner-wrapper">
          {this.props.title ? <div className="mt-product-description-title lap-hide desk-hide mt-menu-title delta palm-gamma">{this.props.title}</div> : null}
          <p className="mt-product-description-text">{this.props.description}</p>
        </div>
      </div>
    );
  }
}

ProductDescription.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string
};

ProductDescription.defaultProps = {
  className: 'mt-product-description-wrapper'
};

export default ProductDescription;



/** WEBPACK FOOTER **
 ** ./core_components/ProductDescription/index.js
 **/